import classNames from 'classnames';
import React from 'react';

import '@eika/card-style/src/ContactCard.scss';

export type ContactCardProps = React.PropsWithoutRef<JSX.IntrinsicElements['article']>;
const ContactCard = ({ children, className, ...rest }: ContactCardProps) => {
    return (
        <article className={classNames('sgw-contact-card__wrapper', className)} {...rest}>
            {children}
        </article>
    );
};

export default ContactCard;
